import { LIBRARY_MODULES_NAMES } from 'constants'
import fetcher from 'utils/fetcher'
import library from 'utils/library'
import { getFeedURLFromOptions } from 'utils/jarvis.xslt'
// #todo - this increases production build gzipped sdk.js size from 4.15 to 4.6 KB
// is it worth ?, or should we write custom util function
import isMobile from 'is-mobile'
import logger from 'utils/logger'
import { mergeDeep, getSafe } from 'utils/common'
import Validator from './validator'

// library's renderer component placeholder
let Renderer

// prerequisitePromise promise is resolved when the library's entry point is loaded
// and the Renderer component of library is also loaded
// eslint-disable-next-line no-async-promise-executor
const prerequisitePromise = new Promise(async (resolve, reject) => {
  try {
    await library.bootstrap()
    await library
      .loadComponent(
        isMobile()
          ? LIBRARY_MODULES_NAMES.RENDERER_MOBILE
          : LIBRARY_MODULES_NAMES.RENDERER_DESKTOP
      )
      .then((component) => {
        Renderer = component.default
      })
    resolve()
  } catch (e) {
    reject()
    logger.log('error in loading core modules:', e)
  }
})

// eslint-disable-next-line import/prefer-default-export
export const loadWidget = (element, options) =>
  // #todo: need to check the risk of disabling this rule
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    const { props = {} } = options

    if (!Validator.isValidLoadWidgetCall(element, options)) {
      reject()
      return
    }

    // multiple parallel calls could be made to render a widget
    const requiredPromises = []

    // feed response from jarvis, which also tells which library component is required
    let { widgetFeed } = options
    // component loaded via library
    let widgetComponent

    try {
      // wait for feed response which tells which component to load
      if (!widgetFeed) {
        await fetcher
          .getJSON(getFeedURLFromOptions(options))
          .then((feedResponse) => {
            widgetFeed = feedResponse
          })
      }

      // if widgetFeed doesn't specify the type (component name as per library)
      // then the component can't be loaded/rendered
      if (!widgetFeed.type) {
        // #todo : log error
        reject()
        return
      }

      // making sure library is ready to be used.
      // doing this later in the loadWidget cycle
      // to make sure resources are loaded only when needed
      // if (!(prerequisitePromise instanceof Promise)) {
      //   init()
      // }

      await prerequisitePromise

      // load the library component needed for this widget
      requiredPromises.push(
        library.loadComponent(widgetFeed.type).then((component) => {
          widgetComponent = component.default
        })
      )

      // load and set data in widgetFeed Response if dataURL value is present in widgetFeed
      // and the data field is absent
      const dataURL = options.dataURL || widgetFeed.dataURL
      if (dataURL) {
        requiredPromises.push(
          fetcher.getJSON(dataURL).then((data) => {
            let resData = data
            widgetFeed.data = widgetFeed.data || {}
            const dataPath = options.dataPath || widgetFeed.dataPath
            if (options.dataPath) {
              resData = getSafe(resData, dataPath)
            }
            if (options.dataAliasKey) {
              widgetFeed.data[options.dataAliasKey] = resData
            } else {
              widgetFeed.data = resData
            }
            mergeDeep(widgetFeed.data, data)
          })
        )
      }

      // wait for all required promises to be resolved calling Renderer
      await Promise.all(requiredPromises)

      // if error in feed / data
      if (widgetFeed.error || (widgetFeed.data && widgetFeed.data.error)) {
        reject()
      }

      // merge props coming in feed and from AffiliatesContent interface
      const mergedProps = {}
      mergeDeep(mergedProps, widgetFeed, props)

      // call the library's Renderer to render the actual component into DOM
      Renderer({
        element,
        Component: widgetComponent,
        props: mergedProps,
        className: options.className,
        colorTheme: options.colorTheme,
        bgTheme: options.bgTheme,
        isAMPIframe: options.isAMPIframe,
      })
      resolve(mergedProps)
    } catch (e) {
      reject()
      logger.log(
        `Error in fetching feed Url or in loading library component--->${e}`
      )
    }
  })
